import { render, staticRenderFns } from "./addCountry.vue?vue&type=template&id=1f882962&scoped=true&"
import script from "./addCountry.vue?vue&type=script&lang=js&"
export * from "./addCountry.vue?vue&type=script&lang=js&"
import style0 from "./addCountry.vue?vue&type=style&index=0&id=1f882962&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f882962",
  null
  
)

export default component.exports